import { useSelector } from "hooks";
import type { ProfileProps } from "store";
import { selectAccountId } from "store/selectors";

export const useIsUserViewer = (userEventProfile: ProfileProps) => {
  const accountId = useSelector(selectAccountId);

  return userEventProfile?.id === accountId;
};
